<template>
  <div class="max-h">
    <table class="ts-w-full">
      <thead>
        <tr>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">{{ $t('stockAdjustment.product') }}</th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-text-center ts-w-20">{{ $t('stockAdjustment.uom') }}</th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-20">{{ $t('stockAdjustment.sysQty') }}</th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-24">{{ $t('stockAdjustment.newQty') }}</th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap">{{ $t('stockAdjustment.diffQty') }}</th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-64">{{ $t('stockAdjustment.reason') }}</th>
          <th class="ts-border ts-border-gray-300 ts-uppercase ts-px-2 ts-py-2 ts-whitespace-no-wrap ts-w-8 ts-text-center">
            {{$t('actions') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
					v-for="(detail, index) in model.sub_item_list"
					:key="index"
          class="ts-border-b ts-border-gray-300"
				>
          <td valign="top" class="ts-px-2 ts-py-1">
            <p class="ts-mb-0 ts-font-extrabold ts-text-blue-600">
              <i class="fab fa-product-hunt"></i> {{ detail.product_name_en }}
            </p>
            <p class="ts-mb-0">
              <i class="fas fa-barcode"></i> {{ detail.barcode }}
            </p>
          </td>
          <td valign="middle" class="ts-w-16 ts-px-2 ts-py-1 ts-text-center">
            <!-- <a-select
              v-model="detail.uom_id" 
              class="ts-w-full"
              :disabled="true"
              :class="{ 'is-invalid': errors.has('sub_item_list.' + index + '.uom_id')}"
            >
              <a-select-option
                v-for="(u, index) in getUom(detail.product_id)"
                :key="index"
                :value="u.uom_id"
              >{{ u.uom_name_en }} </a-select-option>
            </a-select>
            <div class="invalid-feedback" v-if="errors.has('sub_item_list.' + index + '.uom_id')">
              {{ errors.first('sub_item_list.' + index + '.uom_id') }}
            </div> -->
            {{ detail.uom_name_en }}
          </td>
          <td valign="top" class="ts-w-32 ts-px-2 ts-py-1">
            <input
              v-model="detail.current_qty" 
              type="number" 
              class="form-control ts-text-left" readonly 
            />
          </td>
          <td valign="top" class="ts-w-32 ts-px-2 ts-py-1">
            <input
              v-model="detail.new_qty" 
              type="number"
              @input="inputNewQty(detail)"
              @keypress.enter="onNewQtyEnter(index)" 
              class="form-control ts-text-left"
              :class="{ 'is-invalid': errors.has('sub_item_list.' + index + '.new_qty')}" 
            />
						<div class="invalid-feedback" v-if="errors.has('sub_item_list.' + index + '.new_qty')">
              {{ errors.first('sub_item_list.' + index + '.new_qty') }}
            </div>
          </td>
					<td valign="top" class="ts-w-32 ts-px-2 ts-py-1">
            <input
              v-model="detail.qty_different" 
              type="number"
              class="form-control ts-text-left" readonly 
            />
          </td>
					<td valign="top" class="ts-w-32 ts-px-2 ts-py-1">
            <input
              v-model="detail.reason" 
              type="text"
              class="form-control ts-text-left" 
            />
          </td>
          <td class="ts-text-center ts-px-2 ts-py-1" valign="middle">
            <a href="#" class="ts-text-red-600 ts-my-auto"
              @click.prevent="removeRow(detail)"
						>
              <i class="fa fa-trash"></i>
            </a>
          </td>
        </tr>
        
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'productDetails',
	props: ['value', 'validate'],
	data() {
    return {
      errors: new Errors(),
			model: {},
			newRow: {
					product_id: null,
          product_name_en: null,
          barcode: null,
					uom_id: null,
          uom_name_en: null,
					current_qty: null,
					new_qty: null,
					qty_different: null,
					reason: null
			}
		}
	},
	created(){
    this.model = this.value
	},
  computed: {
    ...mapState('stock/adjustment', ['edit_data']),
    ...mapGetters('stock/adjustment', ['getUom', 'isExpirable', 'isDefaultUom']),
    isEdit(){
      return !_.isEmpty(this.edit_data)
    }
	},
	methods: {
    ...mapActions('stock/adjustment', ['getSysQty']),
		addNewRow(){
			this.model.sub_item_list.push(_.clone(this.newRow))
    },
    removeRow(row){
      this.model.sub_item_list.splice(this.model.sub_item_list.indexOf(row), 1)
    },
    inputNewQty(row){
      row.qty_different = row.new_qty - row.current_qty
    },
    onNewQtyEnter(index){
      this.addNewRow()
      this.$nextTick(() => {
        this.$refs.barcode[index + 1].focus()
      })
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>

<style lang="css" scoped>
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

.max-h {
  height: 400px;
  max-height: 420px;
  overflow: scroll;
}
table {
  /* white-space: nowrap; */
  margin: 0;
  /* border-collapse: separate; */
  /* border-spacing: 0;  */
  /* table-layout: fixed; */
  /* border: 1px solid black; */
}
table thead {
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: rgb(22, 102, 145);
  color: white;
}
table tfoot {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background-color: white;
}

</style>
